import React, { useEffect, useState } from "react";
import { useIntl } from "@edx/frontend-platform/i18n";
import {
  FormAutosuggestOption,
  FormControlFeedback,
} from "@openedx/paragon";
import AuthFormAutosuggest from "./AuthFormAutosuggest";
import classNames from "classnames";
import PropTypes from "prop-types";

import { FormGroup } from "../../common-components";
import { getHighSchool } from "../data/service";
import messages from "../messages";

const HighSchoolRo = (props) => {
  const { formatMessage } = useIntl();

  const {
    onChangeHandler,
    selectedTown,
    selectedRegion,
    selectedHighSchool,
    roSelected,
    onFocusHandler,
    errorMessage,
  } = props;

  const [schools, setSchools] = useState([]);
  useEffect(() => {
    const fetchSchools = async () => {
      if (roSelected) {
        const hight = await getHighSchool(
          selectedRegion.selectionValue,
          selectedTown.selectionValue
        );
        setSchools(hight);
      }
      onChangeHandler({ target: { name: "highscoolro", value: "" } });
    };
    fetchSchools();
  }, [selectedRegion, selectedTown]);

  useEffect(() => {
        if (props.errorMessage === undefined){
          return
        }
        if (props.errorMessage !== "") {
          handleOnChange("");
        }
        
      }, [errorMessage]);
  

  const handleOnChange = (value) => {
    onChangeHandler({ target: { name: "highscoolro", value: value } });
  };

  return (
    <div className="mb-4">
      {roSelected ? (
        <AuthFormAutosuggest
          floatingLabel={formatMessage(messages['school.select.ro'])}
          aria-label="form autosuggest"
          name="highscoolro"
          value={selectedHighSchool}
          onFocus={(e) => onFocusHandler(e)}
          className={classNames({ "form-field-error": props.errorMessage })}
          onChange={(value) => handleOnChange(value)}
        >
          {schools.map((school) => (
            <FormAutosuggestOption key={school.id} id={school.id}>
              {school.name}
            </FormAutosuggestOption>
          ))}
        </AuthFormAutosuggest>
      ) : (
        <FormGroup
          name="highscoolro"
          value={selectedHighSchool}
          handleFocus={(e) => onFocusHandler(e)}
          handleChange={onChangeHandler}
          helpText={[formatMessage(messages['school.type.intl'])]}
          floatingLabel={formatMessage(messages['school.type.intl'])}
        />
      )}
      {props.errorMessage !== "" && (
        <FormControlFeedback
          key="error"
          className="form-text\]-size"
          hasIcon={false}
          feedback-for="occupation"
          type="invalid"
        >
          {props.errorMessage}
        </FormControlFeedback>
      )}
    </div>
  );
};

export default HighSchoolRo;
